import script from "./timeAllow.vue?vue&type=script&setup=true&lang=js"
export * from "./timeAllow.vue?vue&type=script&setup=true&lang=js"

import "./timeAllow.vue?vue&type=style&index=0&id=5e151a7b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e151a7b"]])

export default __exports__